export default function asset_version(url) {
    return `${url}?v=2`;
}
